var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentProj)?_c('router-view',{attrs:{"project":_vm.currentProj}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }